/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ReportCrashRequestBody,
  ReportCrashRequestBody$Outbound,
  ReportCrashRequestBody$outboundSchema,
} from "../components/reportcrashrequestbody.js";

export type ReportAgentCrashSecurity = {
  deviceAgentTokenHeaderAuthorization?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type ReportAgentCrashRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Email of the enrolled user, sent in the Gram-User-Email header. Authoritative when authenticating with an org-scoped agent install key; ignored for a per-user key, whose owner is the enrolled user.
   */
  gramUserEmail?: string | undefined;
  /**
   * Hardware serial number of the machine that crashed, when the agent can read it.
   */
  gramDeviceSerial?: string | undefined;
  /**
   * Kind of machine the agent runs on (endpoint, server or ephemeral), sent in the Gram-Device-Environment header.
   */
  gramDeviceEnvironment?: string | undefined;
  reportCrashRequestBody: ReportCrashRequestBody;
};

/** @internal */
export type ReportAgentCrashSecurity$Outbound = {
  device_agent_token_header_Authorization?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ReportAgentCrashSecurity$outboundSchema: z.ZodMiniType<
  ReportAgentCrashSecurity$Outbound,
  ReportAgentCrashSecurity
> = z.pipe(
  z.object({
    deviceAgentTokenHeaderAuthorization: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      deviceAgentTokenHeaderAuthorization:
        "device_agent_token_header_Authorization",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function reportAgentCrashSecurityToJSON(
  reportAgentCrashSecurity: ReportAgentCrashSecurity,
): string {
  return JSON.stringify(
    ReportAgentCrashSecurity$outboundSchema.parse(reportAgentCrashSecurity),
  );
}

/** @internal */
export type ReportAgentCrashRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-User-Email"?: string | undefined;
  "Gram-Device-Serial"?: string | undefined;
  "Gram-Device-Environment"?: string | undefined;
  ReportCrashRequestBody: ReportCrashRequestBody$Outbound;
};

/** @internal */
export const ReportAgentCrashRequest$outboundSchema: z.ZodMiniType<
  ReportAgentCrashRequest$Outbound,
  ReportAgentCrashRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramUserEmail: z.optional(z.string()),
    gramDeviceSerial: z.optional(z.string()),
    gramDeviceEnvironment: z.optional(z.string()),
    reportCrashRequestBody: ReportCrashRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramUserEmail: "Gram-User-Email",
      gramDeviceSerial: "Gram-Device-Serial",
      gramDeviceEnvironment: "Gram-Device-Environment",
      reportCrashRequestBody: "ReportCrashRequestBody",
    });
  }),
);

export function reportAgentCrashRequestToJSON(
  reportAgentCrashRequest: ReportAgentCrashRequest,
): string {
  return JSON.stringify(
    ReportAgentCrashRequest$outboundSchema.parse(reportAgentCrashRequest),
  );
}
